import tgAxios from "@/api/api-axios";
import {
  CreateMeetingPayload,
  MeetingFilter,
  MeetingStatus,
} from "../types/meeting.type";
export const createMeeting = async (payload: CreateMeetingPayload) => {
  return tgAxios.post("/meetings", payload);
};
export const getMeetings = async (params: MeetingFilter) => {
  if (params.page && params.pageSize) {
    const queryString = new URLSearchParams();
    queryString.set("page", params.page.toString());
    queryString.set("pageSize", params.pageSize.toString());
    if (params.status !== MeetingStatus.ALL) {
      queryString.set("status", params.status!.toString());
    }
    if (params.search) {
      queryString.set("search", params.search);
    }
    if (params.roomMeetingId && params.roomMeetingId !== "all") {
      queryString.set("roomMeetingId", params.roomMeetingId);
    }
    if (params.startDate) {
      queryString.set("startDate", params.startDate);
    }
    if (params.endDate) {
      queryString.set("endDate", params.endDate);
    }
    return tgAxios.get(`/meetings?${queryString.toString()}`);
  }
  return tgAxios.get("/meetings");
};
export const getMeetingById = async (id: string) => {
  return tgAxios.get(`/meetings/${id}`);
};
export const getMeetingStatistics = async () => {
  return tgAxios.get(`/meetings/statistics`);
};
export const startMeetingApi = async (id: string) => {
  return tgAxios.patch(`/meetings/${id}/start`);
};
export const stopMeetingApi = async (id: string) => {
  return tgAxios.patch(`/meetings/${id}/stop`);
};
export const deleteMeetingApi = async (id: string) => {
  return tgAxios.delete(`/meetings/${id}`);
};

// Lấy LiveKit token để join meeting
export const getLivekitTokenApi = async ({
  meetingCode,
  participantIdentity,
  participantName,
  role,
}: {
  meetingCode: string;
  participantIdentity: string;
  participantName: string;
  role: string;
}) => {
  return tgAxios.post<{ token: string; serverUrl: string }>(
    `/meetings/generate-token/${meetingCode}`,
    {
      participantIdentity,
      participantName,
      role,
    }
  );
};
